import { RavenInputField, RavenModal } from "@ravenpay/raven-bank-ui";
import React, { useEffect, useState } from "react";
import "../../../../styles/dashboard/insights/AlertReceivers.css";
import { searchGlobalFunction } from "../../../../utils/helpers";
import loadingGif from "../../../../assets/raven-loader.gif";
import { useSelector } from "react-redux";
import RootState from "../../../../redux/types";
import { trimLongString } from "../../../../helper";
import HighlightSearch from "../../../../fragments/HighlightSearch";

interface MyComponentProps {
  visible?: boolean;
  onClose?: () => void;
  onAdd?: () => void;
  onDelete?: (param?: any) => void;
}

const AlertReceivers: React.FC<MyComponentProps> = ({
  visible,
  onClose,
  onDelete,
  onAdd,
}) => {
  const [search, setSearch] = useState("");
  // const receiversList = [
  //   { name: "Adeeko Emmanuel", number: "07015263711" },
  //   { name: "Adeeko Emmanuel", number: "07015263711" },
  //   { name: "Adeeko Emmanuel", number: "07015263711" },
  //   { name: "Adeeko Emmanuel", number: "07015263711" },
  //   { name: "Adeeko Emmanuel", number: "07015263711" },
  //   { name: "Ayeni Kehinde", number: "08162631933" },
  // ];
  const [listToUse, setListToUse] = useState<any>([]);
  const deleteIcon = (
    <svg
      className="img"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.5 2.5H12.5M2.5 5H17.5M15.8333 5L15.2489 13.7661C15.1612 15.0813 15.1174 15.7389 14.8333 16.2375C14.5833 16.6765 14.206 17.0294 13.7514 17.2497C13.235 17.5 12.5759 17.5 11.2578 17.5H8.74221C7.42409 17.5 6.76503 17.5 6.24861 17.2497C5.79396 17.0294 5.41674 16.6765 5.16665 16.2375C4.88259 15.7389 4.83875 15.0813 4.75107 13.7661L4.16667 5M8.33333 8.75V12.9167M11.6667 8.75V12.9167"
        stroke="#FF0F00"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  const { loading_alert, alert_receivers } = useSelector(
    (state: RootState) => state.insights
  );

  useEffect(() => {
    if (search?.length > 0) {
      setListToUse(
        searchGlobalFunction(search, alert_receivers, [
          "fname",
          "phone",
          "lname",
          "contact_email",
        ])
      );
    } else {
      setListToUse(alert_receivers);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search]);

  useEffect(() => {
    if (alert_receivers?.length > 0) {
      // console.log(alert_receivers);

      setListToUse(alert_receivers);
    }
  }, [alert_receivers]);

  return (
    <RavenModal
      onBtnClick={() => {
        onAdd && onAdd();
        // console.log(alert_receivers);
      }}
      btnLabel={!loading_alert ? "Add New Alert Receiver " : ""}
      btnColor="deep-green-light"
      visble={visible}
      onClose={onClose}
      className={`session-expired-wrap-modal`}
    >
      <div className="alert-receiver-modal-wrap-index">
        {loading_alert ? (
          <>
            <div className="loading-wrap">
              <figure className="img-box">
                <img src={loadingGif} alt="" className="img" />
              </figure>
            </div>
          </>
        ) : (
          <>
            <div className="title-text-box">
              <p className="title">Alert Recievers</p>
              <p className="text grey-white-color">
                Some subtext for the modal
              </p>
            </div>

            {alert_receivers?.length > 5 && (
              <div className="search-box-wrap">
                <RavenInputField
                  value={search}
                  onChange={(e: any) => {
                    setSearch(e.target.value);
                  }}
                  color={`deep-green-light`}
                  placeholder="Search"
                />
              </div>
            )}
            <div className="receiver-list-box">
              {listToUse?.length > 0 ? (
                <>
                  {" "}
                  {listToUse?.map((chi: any, idx: any) => {
                    return (
                      <div key={idx} className="item-box border-theme">
                        <div className="name-num-box">
                          <p className="name">
                            {" "}
                            <HighlightSearch
                              text={`${chi?.fname || ""} ${chi?.lname || ""}`}
                              search={search}
                            />
                          </p>
                          <p className="number grey-white-color">
                            +234{" "}
                            <HighlightSearch
                              text={`${chi?.phone || ""}`}
                              search={search}
                            />{" "}
                            • {" "}
                            <HighlightSearch
                              text={`${
                                trimLongString(chi?.contact_email, 20) || ""
                              }`}
                              search={search}
                            />
                          </p>
                        </div>
                        <div
                          onClick={() => {
                            onDelete && onDelete(chi);
                          }}
                          className="delete-box"
                        >
                          <figure className="img-box">{deleteIcon}</figure>
                        </div>
                      </div>
                    );
                  })}
                </>
              ) : (
                <>
                  <div className="no-alert-to-view-box">
                    <p className="grey-white-color">No alert to view</p>
                  </div>
                </>
              )}
            </div>
          </>
        )}
      </div>
    </RavenModal>
  );
};

export default AlertReceivers;
